import styled, { css } from "styled-components";
import { UIWidgetsDiv } from "../division/Division";

const sharedStyle = css`
  width: inherit;
  height: inherit;
  border: none;
  background: #ffffff;
`;
export const DateWrapper = styled(UIWidgetsDiv)`
  width: 100%;
  position: relative;
  > div {
    ${sharedStyle}
    text-align: left;
    border: 1px solid ${props => props.theme.borderLightGrey} !important;
    > div:first-child {
      ${sharedStyle}
      width: 100%;
      height: 100%;
      > div:first-child {
        ${sharedStyle}
        > input {
          ${sharedStyle}
padding: ${props => props.theme.padding12} ${props =>
  props.theme.padding0} ${props => props.theme.padding12} ${props =>
  props.theme.padding24};        }
        > input:focus {
          outline: none;
        }
      }
    }
    > img {
      position: absolute;
      background: white;
      top: 25%;
      right: 5%;
      pointer-events: none;
    }
  }
  .react-datepicker {
    font-size: 1em;
    left:${props => props.theme.margin24};
  }
  .react-datepicker__header {
    padding-top: 0.8em;
  }
  .react-datepicker__month {
    margin: 0.4em 1em;
  }
  .react-datepicker__day-name,
  .react-datepicker__day {
    width: 1.9em;
    line-height: 1.9em;
    margin: 0.166em;
  }
  .react-datepicker__current-month {
    font-size: 1em;
  }
  .react-datepicker__navigation {
    top: 1em;
    line-height: 1.7em;
    border: 0.45em solid transparent;
  }
  .react-datepicker__navigation--previous {
    border-right-color: #ccc;
    left: 1em;
    height:0px !important;
    width:0px !important;
  }
  .react-datepicker__navigation--next {
    border-left-color: #ccc;
    right: 1em;
    height:0px !important;
    width:0px !important;
  }
  .react-datepicker__input-container{
    input{
      width: 98% !important;
      box-sizing:border-box;
      height: 94% !important;
      color: ${props =>
        props.fontStyle ? props.theme.fontGrey : props.theme.black}; 
    }
  }
.react-datepicker-popper {
  z-index: 3;
}
`;
